import React from 'react';
import '../../../Responsive.css';

const BorderedLinesCell = ({ text }) => {
  const lines = (text || '').split(',').map(s => s.trim()); // ✅ fix: split by comma
  return (
    <div>
      {lines.map((line, index) => (
        <div key={index} className="line" style={{ borderBottom: '1px solid #ccc', padding: '4px 0' }}>
          {line}
        </div>
      ))}
    </div>
  );
};

export default BorderedLinesCell;
